let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1z4Vo")).then(() => parcelRequire('6NAyj'));